export const TEST_ID = 'airportWeatherReadout';
